// Chakra imports
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Assets
import Dropzone from "common/components/Dropzone";
import { constant } from "common/constant";
import { MdUpload } from "react-icons/md";

export default function Upload(props) {
  const { used, total, count, ...rest } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const brandColor = useColorModeValue("brand.500", "white");
  const textColorSecondary = "gray.400";
  return (
    <Grid templateColumns="repeat(12, 1fr)" mb={3} gap={2}>
      <GridItem colSpan={{ base: 12, "2xl": 5 }}>
        <Dropzone
          w={{ base: "100%", "2xl": "240px" }}
          me="36px"
          minH={200}
          height={"100%"}
          onFileSelect={props.onFileSelect}
          allowedExtensions={[]} // Allowed file types
          maxSizeInMB={null}
          content={
            <Box display={"flex"} flexDirection="column" alignItems={"center"}>
              <Icon as={MdUpload} w="70px" h="70px" color={brandColor} />
              <Flex justify="center" mx="auto" mb="12px">
                <Text fontSize="xl" fontWeight="700" color={brandColor}>
                  {constant.uploadFiles}
                </Text>
              </Flex>
              <Text fontSize="sm" fontWeight="500" color="secondaryGray.500">
                {count > 0 && (
                  <Text
                    fontSize="sm"
                    fontWeight="500"
                    color="secondaryGray.500"
                  >
                    {constant.selectedFiles} : {count}
                  </Text>
                )}
              </Text>
            </Box>
          }
        />
      </GridItem>
      <GridItem colSpan={{ base: 12, "2xl": 7 }}>
        <Flex direction="column">
          <Text
            color={textColorSecondary}
            fontSize="14px"
            my={{ base: "auto", "2xl": "10px" }}
            mx="auto"
            textAlign="start"
          >
            {constant.uploadFilesDesc}
          </Text>
        </Flex>
      </GridItem>
    </Grid>
  );
}
